import { atom } from "recoil";
import { IEscopoResonsabilidade } from "../../commons/styleds/historicoProdissional";

export const escopoResponsabilidadeAtom = atom<IEscopoResonsabilidade[]>({
  key: 'escopoResponsabilidade',
  default: [] as IEscopoResonsabilidade[],
})

